import { render, staticRenderFns } from "./palmpay.vue?vue&type=template&id=aeec63c8"
import script from "./palmpay.vue?vue&type=script&lang=js"
export * from "./palmpay.vue?vue&type=script&lang=js"
import style0 from "./palmpay.vue?vue&type=style&index=0&id=aeec63c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports